import * as types from './action-types';

import { defineAction } from 'store/common/action-helpers';

const fetchCompaniesInput = input => ({
  pageNo: 1,
  perPage: Number(process.env.REACT_APP_ADMIN_DEFAULT_PAGE_SIZE) || 50,
  ...input,
});

export const fetchCompanies = {
  request: payload => defineAction(types.FETCH_COMPANIES.REQUEST, fetchCompaniesInput(payload)),
  start: payload => defineAction(types.FETCH_COMPANIES.START, fetchCompaniesInput(payload)),
  success: ({ input, result }) =>
    defineAction(types.FETCH_COMPANIES.SUCCESS, { input: fetchCompaniesInput(input), result }),
  failure: ({ input, error }) =>
    defineAction(types.FETCH_COMPANIES.FAILURE, { input: fetchCompaniesInput(input), error }),
};

export const createCompany = {
  request: (values, form) => defineAction(types.CREATE_COMPANY.REQUEST, values, { form }),
  start: values => defineAction(types.CREATE_COMPANY.START, values),
  success: ({ company }) => defineAction(types.CREATE_COMPANY.SUCCESS, { company }),
  failure: error => defineAction(types.CREATE_COMPANY.FAILURE, error),
};

export const updateCompany = {
  request: ({ prettyId, values }, form) =>
    defineAction(types.UPDATE_COMPANY.REQUEST, { prettyId, values }, { form }),
  start: ({ prettyId, values }) => defineAction(types.UPDATE_COMPANY.START, { prettyId, values }),
  success: ({ prettyId, company }) =>
    defineAction(types.UPDATE_COMPANY.SUCCESS, { prettyId, company }),
  failure: ({ prettyId, error }) => defineAction(types.UPDATE_COMPANY.FAILURE, { prettyId, error }),
};

export const deleteCompany = {
  request: ({ prettyId }) => defineAction(types.DELETE_COMPANY.REQUEST, { prettyId }),
  start: ({ prettyId }) => defineAction(types.DELETE_COMPANY.START, { prettyId }),
  success: ({ prettyId }) => defineAction(types.DELETE_COMPANY.SUCCESS, { prettyId }),
  failure: ({ prettyId, error }) => defineAction(types.DELETE_COMPANY.FAILURE, { prettyId, error }),
};



// WEBPACK FOOTER //
// ./src/store/features/admin/companies/actions.js